"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const api_1 = require("../../services/api");
const vehicle_1 = require("./vehicle");
const bodycode_1 = require("../bodycode/bodycode");
const enums_1 = require("../../../@shared-types/vehicle/enums");
let DummyVehicleModel = class DummyVehicleModel {
    constructor(api, vehicle, bodycode) {
        this.api = api;
        this.vehicle = vehicle;
        this.bodycode = bodycode;
        /** Creates a random `DummyVehicle` and returns the Id of it. */
        this.createRandomDummyVehicle = () => __awaiter(this, void 0, void 0, function* () {
            const bodycodes = yield this.bodycode.getManualBodycodes(enums_1.EVehicleManufacturer.FCA);
            const bodycode = bodycodes.bodycodes[Math.floor((Math.random() * bodycodes.bodycodes.length))];
            const req = {
                bodycode: bodycode.bodycode,
                dummyVehicle: true,
                featurePackets: [],
                manufacturer: enums_1.EVehicleManufacturer.FCA,
            };
            const dummyVehicle = yield this.vehicle.postDummyVehicle(req);
            return String(dummyVehicle.vehicleId);
        });
    }
};
DummyVehicleModel = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof api_1.ApiService !== "undefined" && api_1.ApiService) === "function" ? _a : Object, typeof (_b = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _b : Object, typeof (_c = typeof bodycode_1.BodycodeModel !== "undefined" && bodycode_1.BodycodeModel) === "function" ? _c : Object])
], DummyVehicleModel);
exports.default = DummyVehicleModel;
